<template>
  <span
    class="icon"
    :style="inlineSizes"
  >
    <span class="icon__svg">
      <slot>
        <v-icon>
          {{ icon }}
        </v-icon>
      </slot>
    </span>
  </span>
</template>

<script>
export default {
  name: 'props',
  props: {
    size: {
      type: [String, Number],
      default: 0,
    },
    icon: {
      type: String,
      default: null,
    },
  },
  computed: {
    inlineSizes () {
      const size = Number.parseInt(this.size);
      return size < 24 ? null : {
        width: `${size}px`,
        height: `${size}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0;
  line-height: 0;
  position: relative;
  // color: $clr-seopa-blue;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 50%;
    background-color: currentColor;
    opacity: 0.2;
  }

  &__svg {
    width: 40%;
    height: 40%;

    & > * {
      width: 100%;
      height: 100%;
    }

    &::v-deep {
      .v-icon {
        color: currentColor;

        svg {
          display: block;
          width: 100%;
          height: 100%;
          fill: currentColor;
        }
      }
    }
  }

  @media screen and (min-width: 768px) {
    width: 48px;
    height: 48px;
  }

  @media screen and (min-width: 992px) {
    width: 76px;
    height: 76px;
  }
}
</style>
